// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"123":"9b075f8c","526":"2914e82b","643":"3ba2e20c","901":"e27169d4","972":"9621db5e","997":"482cbb11"}[chunkId] + ".chunk.css";
};